import BaseResource from './BaseResource'

export default class CapabilitiesGroup extends BaseResource {
  static endpoint = '/api/v1/capabilitygroups' // /profile
}
